<template>
  <div class="grid grid-cols-2 gap-8 md:gap-0 h-full">
    <main class="col-span-2 flex items-center p-4">
      <div
        class="py-8 px-4 md:px-8 mx-auto flex flex-col justify-center bg-slate-50 rounded-lg shadow-lg w-full max-w-lg h-max"
      >
        <div class="">
          <div class="flex flex-col space-y-8 items-center justify-center">
            <AppLogo />
            <h1 class="gradient-title">Reset password</h1>
          </div>

          <div class="mt-12">
            <div class="mb-6 text-base text-center">Set a new password</div>

            <form class="default-form" @submit.prevent="onSubmit">
              <div>
                <AppInputField
                  v-model="form.password"
                  label="Password"
                  placeholder="Password (min 6 characters)"
                  type="password"
                  autofocus
                >
                  <i class="fa-solid fa-key"></i>
                </AppInputField>
              </div>

              <div>
                <AppInputField
                  v-model="form.password_confirmation"
                  label="Password confirmation"
                  placeholder="Password confirmation"
                  type="password"
                >
                  <i class="fa-solid fa-key"></i>
                </AppInputField>
              </div>

              <div class="flex justify-center">
                <button :disabled="store.sending" type="submit" class="btn btn--lg btn--primary">
                  <i class="fa-solid fa-key"></i>
                  <span>Set password</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script setup lang="ts">
  import { reactive } from 'vue'
  import { useAuth } from '$/composables/useAuth'

  const { route, router, store, sessionStore, pushNotify, pushError, AppInputField, AppLogo } = useAuth()

  const form = reactive({
    password: '',
    password_confirmation: '',
  })

  const config = reactive({
    headers: {
      'access-token': route.query['access-token'],
      client: route.query.client,
      uid: route.query.uid,
    },
  })

  const onSubmit = function () {
    store.sending = true
    sessionStore
      .changePassword(form, config)
      .then((res) => {
        router.push({ name: 'FeatureIndex' })
        pushNotify(res.data.message)
      })
      .catch((err) => {
        const error = err?.response?.data?.errors?.full_messages?.join('\n') || err?.message
        pushError(error)
      })
      .finally(() => (store.sending = false))
  }
</script>
